/* ENGRAM · cartão-presente: os botões de valor (snippets/engram-gift-card) escolhem o valor no seletor do tema,
   escondido por CSS, e disparam «change» — o tema actualiza o preço, a variante e o formulário.
   Teclado: grupo de rádio (setas mudam e escolhem, Tab entra no escolhido). */
(function () {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var info = root.closest('.product__info-container') || document;
    var buttons = Array.prototype.slice.call(root.querySelectorAll('.engram-gc__value'));

    function themeSelect() {
      var name = root.dataset.option;
      var selects = info.querySelectorAll('variant-selects select');
      for (var i = 0; i < selects.length; i++) {
        var n = selects[i].getAttribute('name') || '';
        if (n === name || n === 'options[' + name + ']') return selects[i];
      }
      return selects[0] || null;
    }

    function choose(button, focus) {
      buttons.forEach(function (b) {
        var on = b === button;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      if (focus) button.focus();
      var select = themeSelect();
      if (select && select.value !== button.dataset.value) {
        select.value = button.dataset.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    buttons.forEach(function (b, i) {
      b.addEventListener('click', function () { choose(b, false); });
      b.addEventListener('keydown', function (e) {
        var step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (!step) return;
        e.preventDefault();
        choose(buttons[(i + step + buttons.length) % buttons.length], true);
      });
    });
  }

  function initAll() { document.querySelectorAll('[data-engram-gc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
